// import { SpeculationRules } from "@kunduz/feature-website-common";
import { Redirection, RedirectionProps } from "@kunduz/ui-components";
import { trackEventNext } from "@kunduz/utility-analytics";
import React, { ReactElement } from "react";

export const RedirectionWithContext = (
  props: RedirectionProps,
): ReactElement => {
  const handleButtonClicked = (label: string) => {
    trackEventNext({
      event: "Redirection Component Button Clicked",
      label,
    });
  };

  return (
    <>
      {/* <SpeculationRules prerender={props.buttonItems.map((x) => x.url)} /> */}
      <Redirection {...props} onButtonClicked={handleButtonClicked} />
    </>
  );
};
